
import { Component, Vue } from "vue-property-decorator";
import { SMUser } from "@/store";
import NotificationTemplate from "@/components/NotificationTemplate/NotificationTemplate.vue";

const ICON = "alert-circle";

const NOTIFICATION_PROPS = {
  icon: ICON,
  align: "top",
  color: "primary",
  background: "primary",
  transparent: false,
  boldText: true,
};

@Component({
  components: {
    NotificationTemplate,
  },
})
export default class NotificationSlStarted extends Vue {
  icon = ICON;

  notificationProps = NOTIFICATION_PROPS;

  get isEmployer() {
    return SMUser.isEmployer;
  }

  get text() {
    if (this.isEmployer) return this.$t("text.employer");

    return "";
  }
}
